import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReportNote from '../../../components/ReportNote';
import ReportCard from '../../../components/ReportCard';
import StyledNotesContainer from './StyledNotesContainer';
import useOpposingTeamSelector from '../../../utils/useOpposingTeamSelector';

export default ({ pitcherId, islhb, title }) => {
    const { t: translate } = useTranslation();
    const opponent = useOpposingTeamSelector();
    const levelid = opponent.LevelIDData;
    const [hasTakeAwayNote, setHasTakeAwayNote] = useState(true);
    const hasTakeAwayNoteCallback = (data) => setHasTakeAwayNote(data);
    const reportNoteType = levelid === 8 ? 'oppp' : 'mnhp';

    return (
        <ReportCard title={title ?? translate('sections.opponent.player.key-takeaways')}>
            <StyledNotesContainer>
                {pitcherId && (
                    <ReportNote
                        type={reportNoteType}
                        section={islhb ? 242 : 241}
                        playerId={pitcherId}
                        levelId={levelid}
                        hasDataCallback={hasTakeAwayNoteCallback}
                        showInfo
                    />
                )}
                { !hasTakeAwayNote && <>{translate('sections.opponent.player.none-found')}</>}
            </StyledNotesContainer>
        </ReportCard>
    );
};
